export const PAGE_MODE_SCROLL = 'scroll'
export const PAGE_MODE_PAGE = 'page'



// WEBPACK FOOTER //
// ./src/components/nexum/constants/pageModes.js